module.exports = __webpack_public_path__ + "img/impressum.4418098f.svg";